// The names Maintella uses for a task's time spans, and what each one actually measures.
//
// One list, because these numbers are read side by side — on the monthly report and on a task's
// own report — and two surfaces describing the same span differently is how "Duration +3h" and
// "Lead 3.177h" came to sit in the same product meaning different things with neither saying so.
// `Tasks::Durations` on the backend is the matching list; the definitions below are the wording
// customers see, and the backend's comments point here.
//
// Adding response time (created → accepted) later is one entry here and one there.

export const NOT_REPORTED = 'Not reported';

/**
 * Each entry is a column on the report and a figure on the task page:
 *  - `key`        the field on a report row / the derived value on a task
 *  - `label`      what it is called everywhere it appears
 *  - `definition` the hover text, and the same sentence the docs use
 */
export const TASK_DURATIONS = [
  {
    key: 'lead',
    rowKey: 'task_lead_time_hours',
    label: 'Lead time',
    definition: 'From the task being created to the engineer arriving on site.',
  },
  {
    key: 'on_site',
    rowKey: 'task_time_on_site_hours',
    label: 'Time on site',
    definition: 'From the engineer arriving on site to the task being completed.',
  },
  {
    key: 'cycle',
    rowKey: 'task_cycle_time_hours',
    label: 'Cycle time',
    definition:
      'From the task being created to it being closed — lead time plus time on site.',
  },
  {
    key: 'work',
    rowKey: 'reported_work_time_hours',
    label: 'Work time',
    // Deliberately the odd one out, and said so: everything above is wall-clock arithmetic on
    // the task's timestamps, while this is what the crew typed into a form. They are not
    // expected to agree, and a reader who does not know that will try to reconcile them.
    definition:
      'Total hours reported by the crew on site, not hours per person. Self-reported rather '
      + 'than measured, so it does not have to match time on site.',
  },
];

export const TASK_DURATION_BY_KEY = Object.fromEntries(
  TASK_DURATIONS.map((duration) => [duration.key, duration])
);

/** Hours as the API sends them (a number, or null) → milliseconds for formatDurationShort. */
export function hoursToMs(hours) {
  return Number.isFinite(hours) ? hours * 60 * 60 * 1000 : null;
}
